const Index = () => import('./index.vue');

export default [
    {
        path: '/all/shops',
        name: 'ShopsPage',
        component: Index
    }
]